import { useEffect } from "react";

/**
 * Keeps an open popover on its trigger while the trigger moves: a canvas
 * panning or zooming under it, a page flying in. Popover positioning only
 * listens for scroll and resize, so it re-places each frame while open, as
 * floating-ui's `animationFrame` auto-update does. Render inside the popover.
 */
export function FollowTrigger({
  onMove,
}: {
  onMove: (() => void) | undefined;
}) {
  useEffect(() => {
    if (!onMove) return;
    let frame = requestAnimationFrame(function follow() {
      onMove();
      frame = requestAnimationFrame(follow);
    });
    return () => cancelAnimationFrame(frame);
  }, [onMove]);
  return null;
}
